import React, {useEffect, useState} from 'react';
import Grid from '@material-ui/core/Grid';
import "../../../assets/scss/Static.scss";
import {ActionButtons} from "../../../components/ActionButton";
import MaterialTable from "material-table";
import {getLabel} from "../../../localization/MainLocalization";
import {dir, not_validate_value, sub_directory} from "../../../App";
import {
    material_table_localization,
    material_table_style
} from "../../../components/Material_conf";
import Permissions from "../../../auth/permissions";
import {permissions_data} from "../../../auth/permission_data";
import {BaseClassSessionAthletesAttendeesURL} from "../../../urls";
import {httpRequestWithAuth} from "../../../auth/axios_instance";
import Chip from "@material-ui/core/Chip";


export const AthleteAttendees = props => {
    const athlete_id = props.athlete_id;
    const state = props.history.location.state || {};
    const [data, setData] = useState([]);
    const [is_loading, setIsLoading] = useState(false);
    const [material_table_localization_value] = useState(material_table_localization());

    const columns = [
        {title: getLabel("class_session"), render: rowData => (
                <label>{`${rowData.class_session_name} - ${rowData.class_session_start_time}`}</label>
            )},
        {title: getLabel('coach'), field: 'class_session_staff'},

        {
            title: getLabel("is_present"),
            render: rowData => (
                <Chip color={rowData.is_present ? "primary" : ""} label={getLabel(rowData.is_present_view)}/>
            )
        },
        {
            title: getLabel("is_cancelled"),
            render: rowData => (
                <Chip color={rowData.is_cancelled ? "secondary" : ""} label={getLabel(rowData.is_cancelled_view)}/>
            )
        },
        {title: getLabel('groups'), field: 'athlete_groups', defaultGroupOrder: '1',},
        {title: getLabel('date'), field: 'date_view'},
        {title: getLabel("added_by"), field: 'added_by_name'},
        {title: getLabel("cancelled_by"), field: 'cancelled_by_name'},
    ];


    const listAttendance = async () => {
        await setIsLoading(true);
        let params = {athlete: athlete_id}


        if (!not_validate_value.includes(state.attend_dates)) {
            params['dates'] =  state.attend_dates;
        }

        let response = await httpRequestWithAuth(BaseClassSessionAthletesAttendeesURL, "GET", null, params)
        if (response.status) {
            let temp_data = []
            response.data.map(Attend=>{
                if (Attend.athlete_groups.length > 0){
                    Attend.athlete_groups.map(Group=>{
                        temp_data.push({
                            ...Attend,
                            athlete_groups: Group
                        });
                    })
                }else{
                    temp_data.push({...Attend, athlete_groups: "Without Group"})
                }
            })
            await setData(temp_data);
        }
        await setIsLoading(false);
    }

    const handleBackButton = () => {
        props.history.push(sub_directory + "athletes")
    }


    const handleRowClick = (data) => {
        if (Permissions.checkPermission(permissions_data.classes.view)) {
            props.history.push({
                pathname: `${sub_directory}classes/edit`,
                state: {
                    id: data.class_session,
                    tag: data.class_session_name
                }
            })

        }
    }


    useEffect(()=>{
        listAttendance();
    }, [])



    return (
        <Grid item xs={12}>

            <MaterialTable
                columns={columns}
                isLoading={is_loading}
                data={data}
                onRowClick={(e, rowData) => handleRowClick(rowData)}

                components={{ Groupbar: ()=><></>}}

                options={{
                    actionsColumnIndex: -1,
                    searchFieldAlignment: 'left',
                    showTitle: false,
                    paging: false,
                    rowStyle: {
                        direction: "ltr",
                    },
                    actionsCellStyle:{
                        direction: dir
                    },
                    grouping: true,
                    groupTitle: false,
                }}

                {...material_table_style}
                {...material_table_localization_value}
            />


            <ActionButtons
                allowBack={true}
                backAction={handleBackButton}
            />

        </Grid>
    );
}

